import { BasicLabel, BasicSelect, BasicTextField, SingleDatepicker } from 'components';
import { Column, Row } from 'styles';
import { CredentialCard } from '../Credential';
import { ISettingList, ReqCreateSignUp } from 'domains/Pkg';
import dayjs from 'dayjs';
import { stringToDate } from 'utils';

import { Checkbox } from '@mui/material';
import { useState } from 'react';
import { PrivacyModal, TermsModal } from 'domains/Terms';
interface Props {
  createSignUpRequest: ReqCreateSignUp;
  setCreateSignUpRequest: React.Dispatch<React.SetStateAction<ReqCreateSignUp>>;
  settings?: ISettingList;
  agreedTerms: boolean;
  setAgreedTerms: (agreed: boolean) => void;
}

export const SignUpSecondStep: React.FC<Props> = ({
  createSignUpRequest,
  setCreateSignUpRequest,
  settings,
  agreedTerms,
  setAgreedTerms
}) => {
  const [isTermsModal, setIsTermsModal] = useState(false);
  const [isPrivacyModal, setIsPrivacyModal] = useState(false);

  if (!settings) {
    return null;
  }

  return (
    <Column>
      <Row>
        <Column fullWidth gap="9px">
          <BasicLabel label={'Birth Date'} required />
          <SingleDatepicker
            fullWidth
            initialDate={stringToDate(createSignUpRequest.birthDate)}
            onChange={(date) => {
              if (!date) {
                return;
              }

              setCreateSignUpRequest((prev) => ({
                ...prev,
                birthDate: dayjs(date).format('YYYY-MM-DD')
              }));
            }}
          />
        </Column>

        <Column fullWidth gap="9px">
          <BasicLabel label={'E-mail'} />
          <BasicTextField
            style={{ maxWidth: '257px' }}
            placeholder="Enter your email"
            value={createSignUpRequest.email}
            onChange={(e) => {
              setCreateSignUpRequest((prev) => ({
                ...prev,
                email: e.target.value
              }));
            }}
          />
        </Column>
      </Row>

      <Row>
        <Column fullWidth gap="9px">
          <BasicLabel label={'Desingation'} required />
          <BasicSelect
            style={{ maxWidth: '257px' }}
            placeholder="Select Designation"
            value={createSignUpRequest.designationId}
            options={settings.designationList.map((item) => ({
              label: item.name,
              value: item.id
            }))}
            onChange={(e) => {
              setCreateSignUpRequest((prev) => ({
                ...prev,
                designationId: e.target.value as string
              }));
            }}
          />
        </Column>

        <Column fullWidth gap="9px">
          <BasicLabel label={'Discipline'} required />
          <BasicSelect
            placeholder="Select Discipline"
            style={{ maxWidth: '257px' }}
            value={createSignUpRequest.disciplineId}
            options={settings.disciplineList.map((item) => ({
              label: item.name,
              value: item.id
            }))}
            onChange={(e) => {
              setCreateSignUpRequest((prev) => ({
                ...prev,
                disciplineId: e.target.value as string
              }));
            }}
          />
        </Column>
      </Row>

      <Row>
        <Column fullWidth gap="9px">
          <BasicLabel label={'Nationality'} required />
          <BasicSelect
            placeholder="Select Nationality"
            style={{ maxWidth: '257px' }}
            value={createSignUpRequest.nationId}
            options={settings.nationList.map((item) => ({
              label: item.name,
              value: item.id
            }))}
            onChange={(e) => {
              setCreateSignUpRequest((prev) => ({
                ...prev,
                nationId: e.target.value as string
              }));
            }}
          />
        </Column>

        <Column fullWidth gap="9px">
          <BasicLabel label={'Occupation'} required />
          <BasicSelect
            placeholder="Select Occupation"
            style={{ maxWidth: '257px' }}
            value={createSignUpRequest.occupationId}
            options={settings.occupationList.map((item) => ({
              label: item.name,
              value: item.id
            }))}
            onChange={(e) => {
              setCreateSignUpRequest((prev) => ({
                ...prev,
                occupationId: e.target.value as string
              }));
            }}
          />
        </Column>
      </Row>

      <Row>
        <Column fullWidth gap="9px">
          <BasicLabel label={'Blood Type'} required />
          <BasicSelect
            placeholder="Select Blood Type"
            value={createSignUpRequest.bloodType}
            options={[
              { label: 'A+', value: 'A+' },
              { label: 'A-', value: 'A-' },
              { label: 'B+', value: 'B+' },
              { label: 'B-', value: 'B-' },
              { label: 'AB+', value: 'AB+' },
              { label: 'AB-', value: 'AB-' },
              { label: 'O+', value: 'O+' },
              { label: 'O-', value: 'O-' }
            ]}
            onChange={(e) => {
              setCreateSignUpRequest((prev) => ({
                ...prev,
                bloodType: e.target.value as string
              }));
            }}
          />
        </Column>

        <Column fullWidth gap="9px">
          <BasicLabel label={'Religion'} required />
          <BasicSelect
            placeholder="Select Religion"
            style={{ maxWidth: '257px' }}
            value={createSignUpRequest.religionId}
            options={settings.religionList.map((item) => ({
              label: item.name,
              value: item.id
            }))}
            onChange={(e) => {
              setCreateSignUpRequest((prev) => ({
                ...prev,
                religionId: e.target.value as string
              }));
            }}
          />
        </Column>
      </Row>

      <CredentialCard
        iqamaNo={createSignUpRequest.iqamaNo}
        setIqamaNo={(value) => {
          setCreateSignUpRequest((prev) => ({
            ...prev,
            iqamaNo: value
          }));
        }}
        passportNo={createSignUpRequest.passportNo}
        setPassportNo={(value) => {
          setCreateSignUpRequest((prev) => ({
            ...prev,
            passportNo: value
          }));
        }}
        gatepassNo={createSignUpRequest.gatepassNo}
        setGatepassNo={(value) => {
          setCreateSignUpRequest((prev) => ({
            ...prev,
            gatepassNo: value
          }));
        }}
        iqamaExpiryDate={createSignUpRequest.iqamaExpiryDate}
        setIqamaExpiryDate={(value) => {
          setCreateSignUpRequest((prev) => ({
            ...prev,
            iqamaExpiryDate: value
          }));
        }}
        passportExpiryDate={createSignUpRequest.passportExpiryDate}
        setPassportExpiryDate={(value) => {
          setCreateSignUpRequest((prev) => ({
            ...prev,
            passportExpiryDate: value
          }));
        }}
        gatepassExpiryDate={createSignUpRequest.gatepassExpiryDate}
        setGatepassExpiryDate={(value) => {
          setCreateSignUpRequest((prev) => ({
            ...prev,
            gatepassExpiryDate: value
          }));
        }}
      />

      <Row>
        <Checkbox
          value={agreedTerms}
          onChange={(e) => setAgreedTerms(e.target.checked as boolean)}
        />

        <Row style={{ alignItems: 'center' }}>
          <div>
            I acknowledge that I have read and do hereby accept the
            <span
              style={{ cursor: 'pointer', color: '#2E4CC2', fontSize: '16px', fontWeight: 500 }}
              onClick={() => setIsTermsModal(true)}
            >
              {' Terms of Use '}
            </span>
            <span>and conditions in</span>
            <span
              style={{ cursor: 'pointer', color: '#2E4CC2', fontSize: '16px', fontWeight: 500 }}
              onClick={() => setIsPrivacyModal(true)}
            >
              {' Privacy Statement.'}
            </span>
          </div>
        </Row>
      </Row>

      {isTermsModal && <TermsModal open={isTermsModal} onClose={() => setIsTermsModal(false)} />}
      {isPrivacyModal && (
        <PrivacyModal open={isPrivacyModal} onClose={() => setIsPrivacyModal(false)} />
      )}
    </Column>
  );
};
